<template>
    <div class="member-auth">
        <div class="common-header-wrap">
            <mt-header title="保险购买" class="common-header">
                <mt-button slot="left" icon="back" @click="$router.go(-1)"></mt-button>
            </mt-header>
        </div>
        <div class="content" v-html='article_content'></div>
        <div class="button">
            <mt-button type="default" size="small"  @click="confirmSumit(0)">不同意（仅浏览）</mt-button>
            <mt-button type="danger" size="small" @click="confirmSumit(1)">阅读并同意</mt-button>
        </div>
    </div>
</template>
<script>
    import { getArticleDetail } from '../../../api/homeArticle'
    import { Toast } from 'mint-ui'
    export default {
        name: 'HomeDocument',
        data () {
            return {
                insurance_id: 0,
                article_title: '',
                article_content: ''
            }
        },
        created: function () {
            this.insurance_id = this.$route.query.id;
            let article_id = 44
            getArticleDetail(article_id).then(res => {
                this.article_title = res.result.article_title
                this.article_content = res.result.article_content
            }).catch(function (error) {
                Toast(error.message)
            })
        },
        methods: {
            confirmSumit (status) {
                this.$router.push({ name: 'MemberGas' ,query: { id: this.insurance_id ,status: status} })
            }
        }
    }
</script>
<style  lang="scss" scoped>
    .button{text-align: center;margin-top: 2rem;}
    .button button{width: 40%;}
    .button button:first-child{margin-right: 5%;}
    .content{padding:.5rem;font-size:.7rem;line-height:1rem;}
</style>
